export function getMedicalReferralStatus(
  statusCode: number | undefined,
  dictionary: any,
  isActive?: boolean
) {
  switch (statusCode) {
    case 1:
      return {
        text: isActive ? dictionary.opened : dictionary.cancelled,
        style: isActive
          ? {
              background: '#DBE7FA',
              border: '1px solid #92A5B5',
            }
          : {
              background: '#FFEAED',
              border: '1px solid #FBB2BE',
            },
      };
    case 4:
      return {
        text: isActive ? dictionary.review : dictionary.cancelled,
        style: isActive
          ? {
              background: ' #FFFAE9',
              border: '1px solid #FEECCB',
            }
          : {
              background: '#FFEAED',
              border: '1px solid #FBB2BE',
            },
      };
    case 5:
      return {
        text: isActive ? dictionary.approved : dictionary.cancelled,
        style: isActive
          ? {
              background: '#F4FFF6',
              border: '1px solid #BBE1C1',
            }
          : {
              background: '#FFEAED',
              border: '1px solid #FBB2BE',
            },
      };
    case 7:
      return {
        text: isActive ? dictionary.review : dictionary.cancelled,
        style: isActive
          ? {
              background: ' #FFFAE9',
              border: '1px solid #FEECCB',
            }
          : {
              background: '#FFEAED',
              border: '1px solid #FBB2BE',
            },
      };
    case 8:
      return {
        text: isActive ? dictionary.denied : dictionary.cancelled,
        style: {
          background: '#FFEAED',
          border: '1px solid #FBB2BE',
        },
      };
    default:
      return {
        text: '',
        style: {},
      };
  }
}

export function getMedicalReferralStatusName(
  code: number | null,
  dictionary: any
) {
  switch (code) {
    case 1:
      return dictionary.opened;
    case 4:
      return dictionary.review;
    case 5:
      return dictionary.approved;
    case 7:
      return dictionary.denied;
    case 8:
      return dictionary.denied;
    default:
      return '';
  }
}
